import React from 'react';

function AcceptInvitationComponent() {
    return <></>;
}

export default AcceptInvitationComponent;
